import { lazy } from "react";
import { dashboardSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "transmission" */ './components/EntryPoint'));
const ReportsLoader = lazy(() => import(/* webpackChunkName: "transmissionLoader" */ './components/ReportsLoader'));

export const defaultPath = '/reports';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: ReportsLoader,
        exact: true,
        icon: dashboardSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    }
];

const Reports = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: dashboardSVG,
    title: {
        key: 'Reportes',
        plural: false
    },
    subTitle: {
        key: '',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Reports;
